import { createContext, useContext } from 'react'

export const CitiesContext = createContext(null)
export const useCities = () => {
  const context = useContext(CitiesContext)
  if (!context) {
    throw new Error('useCities must be used within CitiesProvider')
  }
  return context
}
